import type { IState } from '../../../store';
import type { IAddressInfo } from '../../../types/geo/address';

export function addressSelector(state: IState): IAddressInfo[] {
  return state.offerData.offer.geo.address;
}
